import * as React from 'react';

import { ComponentType } from 'shared/entities/components/Component';
import { useTypedTranslation } from 'shared/entities/localization';
import { Button } from 'shared/newComponents/buttons';
import { CircledCheckIcon } from 'shared/newComponents/icons';
import { IconSize } from 'shared/entities/components/Icon';
import Typography from 'shared/newComponents/Typography';
import { ButtonSize } from 'shared/newEntities/components/Button';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';

import './SuccessStep.modules.scss';

type Props = {
  titleId: string;
  titleRef: React.RefObject<HTMLHeadingElement>;
  onAcknowledge: () => void;
};

const SuccessStep: React.FC<Props> = ({
  titleId,
  titleRef,
  onAcknowledge
}: Props) => {
  const { t } = useTypedTranslation('app');

  React.useEffect(() => {
    titleRef.current?.focus();
  }, [titleRef]);

  return (
    <div styleName="success-step">
      <span styleName="success-step__icon">
        <CircledCheckIcon iconSize={IconSize.L} />
      </span>
      <Typography
        ref={titleRef}
        id={titleId}
        Element="h2"
        tabIndex={-1}
        fontType={TypographyType.title}
        fontSize={TypographySize.xs}
        fontWeight={TypographyWeight.bold}
        styleName="success-step__title"
      >
        {t('managerSegment.success.title')}
      </Typography>
      <Typography
        fontType={TypographyType.text}
        fontSize={TypographySize.s}
        fontColor={TypographyColor.secondary}
        styleName="success-step__description"
      >
        {t('managerSegment.success.description')}
      </Typography>
      <Button
        type={ComponentType.button}
        size={ButtonSize.md}
        onClick={onAcknowledge}
        styleName="success-step__button"
      >
        {t('managerSegment.actions.acknowledge')}
      </Button>
    </div>
  );
};

export default React.memo(SuccessStep);
